module.exports = __webpack_public_path__ + "img/orange_032.c16ddcea.png";